import React from 'react';
import { useField } from 'react-final-form';
import { Box, Button, ButtonGroup, NativeButtonProps } from '@ff-it/ui';
import { BaseFieldProps, FormGroup, fieldSubscription, useIsDisabled } from '@ff-it/form';

interface ButtonGroupFieldProps extends Omit<BaseFieldProps, 'placeholder' | 'id' | 'size'> {
  options: {
    value: any;
    label: React.ReactNode;
    disabled?: boolean;
  }[];
  format?: (value: string, name: string) => any;
  parse?: (value: any, name: string) => any;
  size?: NativeButtonProps['size'];
  variant?: NativeButtonProps['variant'];
  fullWidth?: boolean;
}

export function ButtonGroupField(props: ButtonGroupFieldProps): React.ReactElement {
  const {
    name,
    className,
    label,
    options,
    help,
    disabled: propDisabled,
    validate,
    size,
    variant,
    fullWidth,
    ...rest
  } = props;
  const disabled = useIsDisabled(propDisabled);

  const {
    input: { value, onChange },
    meta,
  } = useField<any, HTMLInputElement>(name, {
    subscription: fieldSubscription,
    validate,
  });

  return (
    <FormGroup className={className} label={label} help={help} meta={meta} required={rest.required}>
      <Box>
        {/* @TODO push this down to sdk */}
        <ButtonGroup style={fullWidth ? { display: 'flex', width: '100%' } : undefined}>
          {options.map((option) => (
            <Button
              key={option.value}
              disabled={disabled || option.disabled}
              active={option.value === value}
              onClick={() => onChange(option.value)}
              style={fullWidth ? { flex: '1 1 0' } : undefined}
              size={size}
              variant={variant}
            >
              {option.label}
            </Button>
          ))}
        </ButtonGroup>
      </Box>
    </FormGroup>
  );
}
